<template>
  <div class="stat-panel h-100">
    <div class="stat-panel-head">
      <div>
        <h5>پربازدیدترین محصولات</h5>
        <p class="text-muted mb-0 small">بر اساس تعداد بازدید ثبت‌شده</p>
      </div>
      <i class="bi bi-eye text-primary"></i>
    </div>

    <div v-if="mostViewedProducts.length" class="table-responsive">
      <table class="stat-table text-center">
        <thead>
        <tr>
          <th width="48">رتبه</th>
          <th class="text-right">نام محصول</th>
          <th>بازدید</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in mostViewedProducts" :key="item.id || index">
          <td>
            <span class="stat-rank" :class="{'is-top': index === 0}">{{ index + 1 }}</span>
          </td>
          <td class="stat-product-name">{{ item.name }}</td>
          <td>
            <span class="stat-pill">{{ formatNumber(getProductViewCount(item) || 0) }}</span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-else class="stat-empty">
      <i class="bi bi-eye"></i>
      <p class="mb-0">محصول پربازدیدی یافت نشد.</p>
    </div>

    <div class="stat-pager text-center">
      <pagination class="mx-auto" :meta="pagination" :on-change-page="changePage"/>
    </div>
  </div>
</template>

<script>
import Pagination from "../../dashboard/Pagination.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "StatisticMostViewedProduct",
  components: {Pagination},
  data() {
    return {
      form: {
        page: 1
      },
      pagination: [],
      mostViewedProducts: [],
    }
  },
  methods: {
    formatNumber,
    getMostViewedProducts(form) {
      this.$store.dispatch('Statistic/mostViewedProduct', form).then(res => {
        let baseData = res.data.data;
        this.mostViewedProducts = baseData.data
        this.pagination = baseData.meta
      });
    },
    changePage(page) {
      this.form.page = page
      this.getMostViewedProducts(this.form)
    },
    getProductViewCount(product) {
      let productMeta = product.meta
      if (productMeta != undefined) {
        let viewCount = productMeta.find((item) => {
          return item.name === 'view_count';
        });
        return viewCount == undefined ? null : viewCount.value
      }
      return null
    }
  },
  mounted() {
    this.getMostViewedProducts(this.form)
  }
}
</script>
